import { Container, Typography } from '@mui/joy'

export function TermsOfServicePage() {
    return (
        <Container sx={{ pb: '2rem' }}>
            <Typography
                level="h1"
                sx={{ width: '100%', textAlign: 'center', py: '2rem' }}
            >
                Terms of Service
            </Typography>

            <Typography level="title-sm">
                Effective date: 21 October 2024
            </Typography>
            <Typography textAlign={'justify'} sx={{ pt: '1rem' }}>
                Welcome to EzyMoney, an expense tracking application developed
                by Sachin Kumar, hereinafter referred to as "Company," "we,"
                "us," or "our." These Terms of Service (“Terms”) govern your
                access to and use of the EzyMoney application (the “App”) and
                any related services (collectively, the “Service”). The
                following Terms of Service (“Terms”) will constitute a legally
                binding agreement between you & Company when you use the service
                through the app. Please review the following terms carefully.
                <h4>1. Acceptance of Terms</h4>
                By downloading, installing, or using the App, you agree to
                comply with and be bound by these Terms. If you do not agree to
                these Terms, you must not use the App. The Company reserves the
                right to modify these Terms at any time. Any changes will be
                effective immediately upon posting on this page. Your continued
                use of the Service after changes are made constitutes your
                acceptance of the new Terms. Please review these Terms
                periodically for any updates. Any alleged modification or waiver
                of this Agreement made by the Company through email or phone
                conversations will not be accepted.
                <h4>2. Description of the Service</h4>
                The app allows users to manage their personal financial
                transactions effectively. The application assists you in better
                managing your budget by automatically tracking, categorizing,
                organizing, and presenting the data in a variety of formats.
                <h4>3. User Representations</h4>
                By using our app, you represent and warrant that:
                <ul>
                    <li>
                        You are at least eighteen (18) years old or have the
                        consent of a legal parent or guardian to use the App.
                    </li>
                    <li>
                        You will use the App only for lawful purposes and in
                        accordance with these Terms.
                    </li>
                    <li>
                        You will not use the App in a manner that could damage,
                        disable, overburden, or impair the App or interfere with
                        any other party's use of the App.
                    </li>
                </ul>
                <h4>4. Optional Permissions</h4>
                The App may request certain permissions, such as READ_SMS and
                READ_CONTACTS, to enhance functionality. These permissions are
                entirely optional, and you may grant them based on your
                preferences. You can still use the App without these
                permissions, albeit with limited functionality.
                <h4>6. Data Privacy and Storage</h4>
                We respect your privacy. We may store your SMS messages on our
                secure servers to train our machine learning models, improving
                our ability to identify transactional entities in your SMS. We
                will never access your personal messages, including OTPs,
                passwords, or any other non-transactional content. We do not
                share your data with any third party without your explicit
                consent. For more information, please review our{' '}
                <a href="privacy-policy">Privacy Policy</a>.
                <h4>7. Subscription and Payment</h4>
                By subscribing to our app, you authorize us to charge the
                subscription fees and applicable taxes through your selected
                payment method. You may manage your payment methods through the
                Google Play Store. Prices for subscriptions are subject to
                change, but changes will not affect your current subscription
                plan. You can cancel your subscription at any time, but there
                will be no refunds or credits for partial months of service. The
                Company is not liable for any losses resulting from issues
                during the payment process.
                <h4>8. Third-Party Links</h4>
                The app may contain links to third-party websites or services.
                We have no control over these third-party sites and are not
                responsible for their content or privacy practices. If you
                access any third-party site, you do so at your own risk.
                <h4>9. Intellectual Property</h4>
                All intellectual property rights related to our app, including
                copyrights and trademarks, are owned by the Company. You may not
                use any trademarks or content without our explicit permission.
                <h4>10. Limitation of Liability</h4>
                The Company is not liable for any direct, indirect, incidental,
                special, or consequential damages arising from your use of the
                Service or any features thereof. This includes, but is not
                limited to, any damages resulting from lost data or unauthorized
                access to your information.
                <h4>11. Suspension or Termination</h4>
                The Company reserves the right to suspend or terminate your
                access to the Service at any time, without notice, for any
                violation of these Terms. If your account is terminated for
                violating these Terms, you will not be eligible for any refund
                or credit.
                <h4>12. General Provisions</h4>
                If any provision of these Terms is held to be invalid or
                unenforceable, the remaining provisions will remain in full
                force and effect. These Terms constitute the entire agreement
                between you and the Company regarding your use of the App. These
                Terms are governed by the laws of India. Any disputes arising
                under or in connection with these Terms shall be subject to the
                exclusive jurisdiction of the courts located in New Delhi.
                <h4>13. Acknowledgment</h4>
                By using our app and services, you acknowledge that you have
                read these Terms, understand them, and agree to be bound by
                them. If you have any questions about these Terms, please
                contact us at{' '}
                <a href="mailto:kr771.sachin@gmail.com">
                    kr771.sachin@gmail.com
                </a>
                .
            </Typography>
        </Container>
    )
}
